<div class="changes-card" [style.border-color]="borderColour" [style.background-color]="backgroundColour">
  <div class="changes-title">{{ label }}</div>
  <div class="changes-grid">
    <div *ngFor="let item of changes" class="d-flex flex-column gap-2 data-field">
      <div class="data-label">{{ item.key }}</div>
      <div class="data-value">{{ item.value }}</div>
    </div>
  </div>
</div>
